import { Box, Drawer, useMediaQuery, useTheme } from "@mui/material";
import { useState } from "react";
import { Outlet } from "react-router-dom";
import LmsHeader from "./LmsHeader";
import LmsSideNav from "./LmsSideNav";
import LmsMain from "./LmsMain";

function LmsLayout() {
  const drawerWidth = 265;
  const [mobileOpen, setMobileOpen] = useState(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  return (
    <Box sx={{ display: "flex" }}>
      {/* Sidebar Navigation */}
      {isMobile ? (
        <Drawer
          variant="temporary"
          open={mobileOpen}
          onClose={handleDrawerToggle}
          ModalProps={{
            keepMounted: true,
          }}
          sx={{
            display: { xs: "block", md: "none" },
            "& .MuiDrawer-paper": {
              boxSizing: "border-box",
              width: drawerWidth,
              backgroundColor: "primary.main",
              color: "primary.contrastText",
            },
          }}
        >
          <LmsSideNav
            drawerWidth={drawerWidth}
            handleDrawerToggle={handleDrawerToggle}
          />
        </Drawer>
      ) : (
        <Box
          sx={{
            width: drawerWidth,
            backgroundColor: "primary.main",
            color: "primary.contrastText",
            height: "100vh",
            position: "fixed",
            overflowY: "auto",
          }}
        >
          <LmsSideNav
            drawerWidth={drawerWidth}
            handleDrawerToggle={handleDrawerToggle}
          />
        </Box>
      )}

      {/* Main Content Area */}
      <Box
        sx={{
          width: { xs: "100%", md: `calc(100% - ${drawerWidth}px)` },
          ml: { xs: 0, md: `${drawerWidth}px` },
          display: "flex",
          flexDirection: "column",
          minHeight: "100vh",
        }}
      >
        <LmsHeader
          drawerWidth={drawerWidth}
          handleDrawerToggle={handleDrawerToggle}
        />
        <LmsMain>
          <Outlet />
        </LmsMain>
      </Box>
    </Box>
  );
}

export default LmsLayout;

